import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Form, Button, Container } from "react-bootstrap";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const getAuthToken = () => localStorage.getItem("authToken");

const EditReceipt = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [accounts, setAccounts] = useState([]);
    const [cashAccounts, setCashAccounts] = useState([]);
    const [receipt, setReceipt] = useState({
        date: "",
        receipt_number: "",
        from_account: "",
        to_account: "",
        from_account_id: "",
        to_account_id: "",
        amount: "",
        description: "",
    });

    useEffect(() => {
        fetchReceipt();
        fetchAccounts();
        fetchCashAccounts();
    }, []);

    const fetchReceipt = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-one-receipt?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setReceipt(response.data.receipt);
        } catch (error) {
            console.error("Error fetching receipt:", error);
        }
    };

    const fetchAccounts = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-accounts`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setAccounts(response.data.data);
        } catch (error) {
            console.error("Error fetching accounts:", error);
        }
    };

    const fetchCashAccounts = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.post(
                `${appConstants.API_ROOT_URL}get-accounts`,
                { account_type_ids: [9, 10] },
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            setCashAccounts(response.data.data);
        } catch (error) {
            console.error("Error fetching cash accounts:", error);
        }
    };

    const handleFromAccountSelection = (e) => {
        const selectedAccount = accounts.find(acc => acc.name === e.target.value);
        if (selectedAccount) {
            setReceipt({
                ...receipt,
                from_account_id: selectedAccount.id,  // Store ID
                from_account: selectedAccount.name   // Store Name
            });
        } else {
            setReceipt({
                ...receipt,
                from_account_id: "",
                from_account: e.target.value // Allow manual input
            });
        }
    };

    const handleToAccountSelection = (e) => {
        const selectedAccount = cashAccounts.find(acc => acc.name === e.target.value);
        if (selectedAccount) {
            setReceipt({
                ...receipt,
                to_account_id: selectedAccount.id,  // Store ID
                to_account: selectedAccount.name   // Store Name
            });
        } else {
            setReceipt({
                ...receipt,
                to_account_id: "",
                to_account: e.target.value // Allow manual input
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
    
        const payload = {
            receipt_id: id,  // Ensure `receipt_id` is included
            from_account_id: receipt.from_account_id,
            to_account_id: receipt.to_account_id,
            amount: parseFloat(receipt.amount), // Ensure amount is numeric
            date: receipt.date,
            description: receipt.description || "", // Ensure description is not undefined
        };
    
        try {
            const response = await axios.post(`${appConstants.API_ROOT_URL}update-receipt`, payload, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
    
            alert(response.data.message || "Receipt updated successfully!");
            navigate("/receipt-list");
        } catch (error) {
            console.error("Error updating receipt:", error);
            alert(error.response?.data?.message || "Error updating receipt. Please try again.");
        }
    };
    
      

    return (
        <Layout>
            <h4>Edit Receipt</h4>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-2">
                    <Form.Label>Date</Form.Label>
                    <Form.Control type="date" name="date" value={receipt.date} onChange={(e) => setReceipt({ ...receipt, date: e.target.value })} required />
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>Received From</Form.Label>
                    <Form.Control
                        list="accounts"
                        value={receipt.from_account}
                        onChange={handleFromAccountSelection}
                    />
                    <datalist id="accounts">
                        {accounts.map(account => (
                            <option key={account.id} value={account.name} data-id={account.id}>{account.name}</option>
                        ))}
                    </datalist>
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>To Account</Form.Label>
                    <Form.Control
                        list="cash-accounts"
                        value={receipt.to_account}
                        onChange={handleToAccountSelection}
                    />
                    <datalist id="cash-accounts">
                        {cashAccounts.map(account => (
                            <option key={account.id} value={account.name} data-id={account.id}>{account.name}</option>
                        ))}
                    </datalist>
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control type="number" name="amount" value={receipt.amount} onChange={(e) => setReceipt({ ...receipt, amount: e.target.value })} required />
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>Description</Form.Label>
                    <Form.Control type="text" name="description" value={receipt.description} onChange={(e) => setReceipt({ ...receipt, description: e.target.value })} />
                </Form.Group>

                <Button type="submit" variant="primary">Update Receipt</Button>
                <Button variant="secondary" className="ms-2" onClick={() => navigate(-1)}>Cancel</Button>
            </Form>
        </Layout>
    );
};

export default EditReceipt;
